var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "16",
        height: "15",
        viewBox: "0 0 16 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M2 14.518H14C15.1031 14.518 16 13.6211 16 12.518V4.51801C16 3.41488 15.1031 2.51801 14 2.51801H9C8.68437 2.51801 8.3875 2.37113 8.2 2.11801L7.6 1.31801C7.22187 0.81488 6.62813 0.518005 6 0.518005H2C0.896875 0.518005 0 1.41488 0 2.51801V12.518C0 13.6211 0.896875 14.518 2 14.518Z",
          fill: "currentColor",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }